import styled, { css } from 'styled-components';
import { TPropsSC } from './button';

import {
  COLOR_BUTTON_PRIMARY,
  COLOR_RED,
  COLOR_WHITE,
} from '@common/assets/styles/colors';

export const SuffixSC = styled.div`
  position: absolute;
  right: 7%;
  max-height: 100%;
`;
export const PrefixSC = styled.div`
  position: absolute;
  left: 7%;
  max-height: 100%;
`;

export const ButtonSC = styled.button<TPropsSC>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  transition: 0.2s all;
  white-space: nowrap;
  line-height: 1;

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${({ size, shape }) => {
    switch (size) {
      case 'small':
        return css`
          padding: 0 26px;
          height: 24px;
          border-radius: 5px;
          ${shape === 'round'
            ? css`
                height: 24px;
                border-radius: 12px;
                padding: 2px;
              `
            : ''}
        `;

      case 'medium':
        return css`
          padding: 0 26px;
          height: 30px;
          border-radius: 5px;
          ${shape === 'round'
            ? css`
                height: 30px;
                border-radius: 15px;
                padding: 13px;
              `
            : ''}
        `;
      case 'large':
        return css`
          padding: 0 30px;
          height: 40px;
          border-radius: 10px;
          width: 100%;
          ${shape === 'round'
            ? css`
                height: 40px;
                border-radius: 20px;
                padding: 15px;
              `
            : ''}
        `;
      default:
        return css`
          padding: 0 24px;
          height: 50px;
          border-radius: 10px;
          ${shape === 'round'
            ? css`
                height: 50px;
                border-radius: 25px;
                padding: 12px;
              `
            : ''}
        `;
    }
  }}

  ${({ isBlock }) =>
    isBlock
      ? css`
          display: block;
          width: 100%;
        `
      : ''}

  ${({ variation }) => {
    switch (variation) {
      case 'primary':
        return css`
          color: ${COLOR_WHITE};
          background: ${COLOR_BUTTON_PRIMARY};
          box-shadow: 0 0 15px 0 rgba(106, 213, 229, 0.45);
        `;
      case 'warn':
        return css`
          color: ${COLOR_WHITE};
          background: ${COLOR_RED};
          box-shadow: 0 0 15px 0 rgba(255, 51, 92, 0.5);
        `;
      case 'link':
        return css`
          color: #181e34;
          background: transparent;

          &:hover {
            text-decoration: underline;
          }
        `;
      default:
        return css`
          color: #323d6f;
          background: #eaebf0;
        `;
    }
  }}
`;
